import React from 'react';
import styles from './Tabs.module.css';

export type TabsVariant = 'default' | 'compact' | 'underline' | 'pill';

export interface TabsProps {
  children: React.ReactNode;
  variant?: TabsVariant;
  className?: string;
}

const Tabs: React.FC<TabsProps> = ({ children, variant = 'default', className = '' }) => {
  // Get base class based on variant
  const getVariantClass = () => {
    switch (variant) {
      case 'compact':
        return styles.tabsCompact;
      case 'underline':
        return styles.tabsUnderline;
      case 'pill':
        return styles.tabsPill;
      default:
        return styles.tabs;
    }
  };

  const finalClassName = className ? `${getVariantClass()} ${className}` : getVariantClass();
  
  return (
    <div className={finalClassName}>
      {children}
    </div>
  );
};

export default Tabs;

